import { createSlice } from '@reduxjs/toolkit';

import { ITemplateInitial } from './template.types';
import { actions } from './template.actions';

const initialState: ITemplateInitial = {
  templates: [],
};

const templateSlice = createSlice({
  name: 'templateSlice',
  initialState,
  reducers: actions,
});

export const templateReducer = templateSlice.reducer;
export const { setTemplates } = templateSlice.actions;
